import type { UniformPricingTiersTableProps } from './pricing-tiers-table.tsx';

export const pricingTiersTableContentType = 'pricingTableRef';

export interface RenderPricingTiersTableEmbeddedEntryArgs {
	fields: unknown;
}

export function renderPricingTiersTableEmbeddedEntry(
	args: RenderPricingTiersTableEmbeddedEntryArgs,
): string | undefined {
	const { fields } = args;
	const pricingTableFields = fields as
		| Partial<
				Pick<UniformPricingTiersTableProps, 'sku' | 'title' | 'titleHref' | 'billingCycle' | 'unit'>
		  >
		| undefined;
	if (
		!pricingTableFields?.sku ||
		!pricingTableFields.title ||
		!pricingTableFields.titleHref ||
		!pricingTableFields.billingCycle
	) {
		return undefined;
	}

	const { sku, title, titleHref, billingCycle, unit } = pricingTableFields;
	const props = { sku, title, titleHref, billingCycle, unit };
	return `<div data-pricing-tiers-table="${encodeURIComponent(JSON.stringify(props))}"></div>`;
}
